export const MOBILE_OS = {
  ANDROID: 'ANDROID',
  IOS: 'IOS',
}

export function useMobileOS() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  let mobileOS = null

  if (/android/i.test(userAgent)) {
    mobileOS = MOBILE_OS.ANDROID
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    mobileOS = MOBILE_OS.IOS
  }

  const isAndroid = mobileOS === MOBILE_OS.ANDROID
  const isIOS = mobileOS === MOBILE_OS.IOS
  const isMobileOS = isAndroid || isIOS

  return { mobileOS, isAndroid, isIOS, isMobileOS }
}

export default useMobileOS
